<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Ubah Pelanggan</h2>
								<form>
									<div class="row row-space">
										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Nama<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="name"
													v-model="form.name"
													placeholder="Ketik Nama Pelanggan"
												/>
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Nomor Telepon<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="phone"
													v-model="form.phone_number"
													placeholder="Ketik Nomor Telepon Pelanggan"
												/>
											</div>
										</div>
									</div>
									<div class="row row-space">
										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>KTP<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="ktp"
													v-model="form.ktp"
													placeholder="Ketik KTP"
												/>
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Alamat<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="address"
													v-model="form.address"
													placeholder="Ketik Alamat Pelanggan"
												/>
											</div>
										</div>
									</div>
									<div class="row row-space">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
										<div class="input-group">
											<label class="label">Email<span style="color: red;">*</span></label>
											<input class="input--style-4" type="text" name="ktp" v-model="form.email" placeholder="Ketik Email">
										</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
										<div class="input-group">
											<label class="label">Tgl Lahir<span style="color: red;">*</span></label>
											<flat-pickr
												v-model="form.dob"
												:config="rangeConfig"
												placeholder="Pilih Tanggal"
											></flat-pickr>
											<!-- <input class="input--style-4" type="text" name="address" v-model="form.dob" placeholder="Isi Tanggal Lahir"> -->
										</div>
										</div>
									</div>
									<div class="row row-space">
										<div class="col-12">
											<label class="label text-left"
												>Ubah Gambar KTP</label
											>
											<div v-if="!form.image">
												<div
													:class="[
														'dropZone',
														dragging
															? 'dropZone-over'
															: '',
													]"
													@dragenter="dragging = true"
													@dragleave="
														dragging = false
													"
												>
													<div
														class="dropZone-info"
														@drag="onChange"
													>
														<span
															class="fa fa-cloud-upload dropZone-title"
														></span>
														<span
															class="dropZone-title"
															>Taruh gambar atau
															klik untuk
															meng-unggah</span
														>
														<div
															class="dropZone-upload-limit-info"
														>
															<div>
																extension
																support: png,
																jpg, jpeg
															</div>
															<div>
																ukuran file
																maksimum: 2 MB
															</div>
														</div>
													</div>
													<input
														type="file"
														@change="onChange"
													/>
												</div>
											</div>
											<div
												v-else
												class="dropZone-uploaded"
											>
												<div
													class="dropZone-uploaded-info"
												>
													<span class="dropZone-title"
														>Berhasil
														Di-unggah</span
													>
													<button
														type="button"
														class="btn btn-primary removeFile"
														@click="form.image = ''"
													>
														Hapus File
													</button>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div
											class="col mt-5"
											style="text-align: center"
										>
											<button
												type="button"
												class="btn btn-outline-danger"
												style="font-size:140%"
												@click="$emit('closeModal')"
											>
												Kembali
											</button>
											<button
												type="button"
												class="btn btn-primary ml-5"
												style="font-size:150%"
												@click="submitForm()"
											>
												Ubah
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import MultiSelect from "vue-multiselect";
import FormData from "form-data";
import env from '@/env'

export default {
	data() {
		return {
			file: "",
			dragging: false,
			form: {
				name: "",
				phone_number: "",
				ktp: "",
				address: "",
				image: "",
			},
			rangeConfig: {
				altInput: true,
				altInputClass: 'input--style-4 w-100',
				animate: !this.isRTL()
			},
		};
	},
	props: ["editObject"],
	components: {
		MultiSelect,
	},
	mounted() {
		//Auto Fill
		for (var key in this.form)
			this.form[key] = this.editObject[key] ? this.editObject[key] : "";
	},
	watch: {},
	methods: {
		onChange(e) {
			var files = e.target.files || e.dataTransfer.files;

			if (!files.length) {
				this.dragging = false;
				return;
			}

			this.createFile(files[0]);
		},
		createFile(file) {
			if (
				!file.type.match("image.png") &&
				!file.type.match("image.jpg") &&
				!file.type.match("image.jpeg")
			) {
				this.$store.dispatch("triggerAlert", [
					false,
					["Mohon memilih file dengan tipe png, jpeg, or jpg"],
				]);
				this.dragging = false;
				return;
			}

			if (file.size > 8000000) {
				this.$store.dispatch("triggerAlert", [
					false,
					["Mohon memilih file dengan ukuran tidak melibihi 8 MB."],
				]);
				this.dragging = false;
				return;
			}

			this.form.image = file;
			console.log(this.form.image);
			this.dragging = false;
		},
		validateForm() {
			var valid = true;
			var error = [];

			if (this.form.name == "" || this.form.name == null) {
				//Name [Required]
				valid = false;
				error.push("Nama wajib diisi!");
			}

			if (
				this.form.phone_number == "" ||
				this.form.phone_number == null
			) {
				//Phone Number [Required]
				valid = false;
				error.push("Nomor Telepon wajib diisi!");
			}
			if (!isNaN(this.phone_number)) {
				//Phone Number not number
				valid = false;
				error.push("Nomor Telepon Hanya Dapat Diisi Dengan Nomor!");
			}

			if (this.form.ktp == "" || this.form.ktp == null) {
				//Address [Required]
				valid = false;
				error.push("KTP wajib diisi!");
			}

			if (this.form.address == "" || this.form.address == null) {
				//Address [Required]
				valid = false;
				error.push("Alamat wajib diisi!");
			}

			if (this.form.image == "" || this.form.image == null) {
				//Ubah Gambar KTP
				delete this.form.image;
			}

			if (!valid) this.$store.dispatch("triggerAlert", [false, error]);
			else return valid;
		},
		async submitUpdate(form) {
      		let vm = this;
			this.$http
				.put(
					`/api/v1/masterData/customer/${this.editObject.id}`,
					form
				)
				.then((resp) => {
					// alert(`Partshop ${vm.form.name} has been created`);
					this.$store.dispatch("triggerAlert", [
						true,
						[`Pelanggan ${vm.form.name} telah berhasil diubah`],
					]);
					this.$emit("updateTable");
					this.$emit("closeModal");
				})
				.catch((err) => {
					console.log(err);
					this.$store.dispatch("triggerAlert", [
						false,
						String(err)
							.split("Error:")[1]
							.split("; "),
					]);
				});
		},
		async submitForm() {
			let vm = this;
			if (vm.validateForm()) {
				if (this.form.image) {

					let formData = new FormData()
					console.log(this.form.image)

					formData.append('work_order', this.form.image)
					this.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})
					.then((resp) => {
						this.form.ktp_img = resp.data.data.filename
						delete this.form.image
						this.submitUpdate(this.form)
						
					})
					.catch((err) =>{
						console.log(err)
						this.$store.dispatch('triggerAlert', [false, (String(err).split("Error:"))[1].split("; ")]);
					})

				} else {
          			this.submitUpdate(this.form)
				}
				//Create new form data object
				
			}
		},
	},
};
</script>

<style scoped>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

/* FILE DRAG N' DROP START */
.dropZone {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone:hover {
	border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
	color: #1975a0;
}

.dropZone-info {
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.dropZone-title {
	color: #787878;
}

.dropZone input {
	position: absolute;
	cursor: pointer;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.dropZone-upload-limit-info {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.dropZone-over {
	background: #5c5c5c;
	opacity: 0.8;
}

.dropZone-uploaded {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone-uploaded-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.removeFile {
	width: 200px;
}
/* FILE DRAG N' DROP END */
</style>
